import { GeneralFeedback } from 'types/Feedback';

export const defaultFeedback: GeneralFeedback['feedbackData'] = {
  purpose: '',
  purposeDescription: '',
  primaryTargeting: '',
  primaryTargetingDescription: '',
  industry: '',
};

export const purposeOptions = [
  {
    label: 'Ich möchte Werbung für mein eigenes Unternehmen schalten',
    value: 'company',
  },
  {
    label: 'Ich bin eine Agentur und möchte Werbung für meine Kunden schalten',
    value: 'agency',
  },
  {
    label: 'Ich möchte Alloy Ads anders nutzen',
    value: 'other',
  },
];

export const industryOptions = [
  {
    label: 'Technologie (Software, IT-Dienstleistungen, Hardware)',
    value: 'technology',
  },
  {
    label: 'Gesundheitswesen & Life Sciences (Krankenhäuser, Pharma, Biotech)',
    value: 'healthcare',
  },
  {
    label: 'Finanzdienstleistungen (Bankwesen, Versicherungen, Investment)',
    value: 'financial',
  },
  {
    label: 'Einzelhandel & E-Commerce (Konsumgüter, Online-Shops)',
    value: 'retail',
  },
  {
    label: 'Herstellung & Industrie (Produktion, Maschinenbau, Automobil)',
    value: 'manufacturing',
  },
  {
    label: 'Professionelle Dienstleistungen (Beratung, Recht, Marketing, Buchhaltung)',
    value: 'professional',
  },
  {
    label: 'Bildungswesen (Schulen, Universitäten, EdTech)',
    value: 'education',
  },
  {
    label: 'Gastgewerbe & Gastronomie (Hotels, Restaurants, Reisen)',
    value: 'hospitality',
  },
  {
    label: 'Bauwesen & Immobilien (Baugewerbe, Immobilienverwaltung)',
    value: 'construction',
  },
  {
    label: 'Öffentlicher Sektor & Non-Profit',
    value: 'public',
  },
  {
    label: 'Sonstiges',
    value: 'other',
  },
];

export const targetingOptions = [
  {
    label: 'An Unternehmen (B2B)',
    value: 'b2b',
  },
  {
    label: 'An Endkund:innen (B2C)',
    value: 'b2c',
  },
  {
    label: 'Beides',
    value: 'other',
  },
];
